import * as Yup from 'yup';
import { Locale } from '@synergy/models';
import { fields } from '@synergy/utils';

import { CategoryFormikValues } from '../models/category-formik-values';

const fieldNames = fields<CategoryFormikValues>();

export const categoriesModalValidationSchema = (locale: Locale) =>
    Yup.object().shape({
        [fieldNames.translations]: Yup.object().shape({
            [locale]: Yup.string().required('app.error.required'),
        }),
    });
